import {
  Description,
  Divider,
  PrivacyTermsAppWrapper,
  Title,
} from 'components/terms/Terms.styled';

export const PERSONAL_INFORMATION_HISTORY: Record<string, JSX.Element> = {
  '': (
    <PrivacyTermsAppWrapper>
      <Title>[필수] 개인정보 수집 및 이용 동의</Title>
      <Description>
        ㈜오픈서베이(이하 “회사”)는 네이버페이 포인트 전환 서비스 제공을 위해
        다음과 같이 개인정보를 수집·이용합니다.
      </Description>
      <Divider />
      <p>수집 항목</p>
      <p>
        네이버 unique ID, 네이버 아이디(마스킹 형태), 네이버페이 회원
        키(userKey), 네이버 계정의 휴대전화번호, 네이버페이 포인트 잔액 정보
      </p>
      <br />
      <br />
      <p>수집·이용 목적</p>
      <ul style={{ listStyle: 'inside' }}>
        <li>
          네이버 계정 연동 및 본인 확인 (오베이-네이버 휴대전화번호 일치 여부
          확인)
        </li>
        <li>네이버페이 포인트 전환 대상 사용자 식별 및 정보 표시</li>
        <li>전환 가능 포인트 안내 및 거래 처리</li>
      </ul>
      <br />
      <br />
      <p>보유 및 이용 기간</p>
      <ul style={{ listStyle: 'inside' }}>
        <li>
          <b>
            수집된 정보는 전환 요청 처리 및 사용자 식별을 위해 일시적으로
            사용되며, 처리 완료 시 즉시 파기
          </b>
        </li>
      </ul>
      <Description>
        <p>동의를 거부할 권리 및 불이익 안내</p>
        <ul style={{ listStyle: 'inside' }}>
          <li>
            제3자 제공에 동의하지 않으실 경우, 네이버페이 포인트 전환 서비스를
            이용하실 수 없습니다.
          </li>
        </ul>
      </Description>
    </PrivacyTermsAppWrapper>
  ),
};
